import Immutable from 'immutable';

const initialState = Immutable.Map();

function showStarted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], true)
    .setIn([payload.id.toString(), 'show', 'completed'], false)
    .setIn([payload.id.toString(), 'show', 'failed'], false)
    .setIn([payload.id.toString(), 'errors'], {});
}

function showCompleted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'show', 'completed'], true)
    .setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload))
    .setIn([payload.id.toString(), 'show', 'failed'], false)
    .setIn([payload.id.toString(), 'show', 'errors'], {});
}

function showFailed(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'show', 'completed'], false)
    .setIn([payload.id.toString(), 'show', 'failed'], true)
    .setIn(
      [payload.id.toString(), 'show', 'errors'],
      Immutable.fromJS(payload.errors)
    );
}

function updateStarted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], true)
    .setIn([payload.id.toString(), 'update', 'completed'], false)
    .setIn([payload.id.toString(), 'update', 'failed'], false)
    .setIn([payload.id.toString(), 'update', 'errors'], {});
}

function showCached(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'show', 'completed'], true);
}

function updateCompleted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update', 'completed'], true)
    .setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload))
    .setIn([payload.id.toString(), 'update', 'failed'], false)
    .setIn([payload.id.toString(), 'update', 'errors'], {});
}

function updateFailed(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update', 'completed'], false)
    .setIn([payload.id.toString(), 'update', 'failed'], true)
    .setIn(
      [payload.id.toString(), 'update', 'errors'],
      Immutable.fromJS(payload.errors)
    );
}

function updateAtlasStarted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], true)
    .setIn([payload.id.toString(), 'update_atlas', 'completed'], false)
    .setIn([payload.id.toString(), 'update_atlas', 'failed'], false);
}

function updateAtlasCompleted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update_atlas', 'completed'], true)
    .setIn([payload.id.toString(), 'update_atlas', 'failed'], false)
    .setIn([payload.id.toString(), 'update_atlas', 'errors'], payload.error);
}

function updateAtlasFailed(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update_atlas', 'completed'], false)
    .setIn([payload.id.toString(), 'update_atlas', 'failed'], true)
    .setIn([payload.id.toString(), 'update_atlas', 'errors'], payload.errors);
}

function updatePasswordStarted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], true)
    .setIn([payload.id.toString(), 'update_password', 'completed'], false)
    .setIn([payload.id.toString(), 'update_password', 'failed'], false);
}

function updatePasswordCompleted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update_password', 'completed'], true)
    .setIn([payload.id.toString(), 'update_password', 'failed'], false)
    .setIn([payload.id.toString(), 'update_password', 'errors'], payload.error);
}

function updatePasswordFailed(state, payload) {
  return state
    .setIn([payload.id.toString(), 'loading'], false)
    .setIn([payload.id.toString(), 'update_password', 'completed'], false)
    .setIn([payload.id.toString(), 'update_password', 'failed'], true)
    .setIn(
      [payload.id.toString(), 'update_password', 'errors'],
      payload.errors
    );
}

function resetUpdatePasswordState(state, payload) {
  state.setIn([payload.id.toString(), 'update_password', 'completed'], false);
  state.setIn([payload.id.toString(), 'update_password', 'failed'], false);
  return state.setIn([payload.id.toString(), 'update_password', 'errors'], {});
}

function showAccountUsersCompleted(state, payload) {
  return state
    .setIn(
      [payload.owner[0][0].toString(), 'owner', 'completed'],
      payload.owner[0]
    )
    .setIn(
      [payload.owner[0][0].toString(), 'users', 'completed'],
      payload.users
    );
}

function pendingInvitationCompleted(state, payload) {
  return state
    .setIn([payload.id.toString(), 'subUsers', 'completed'], payload.sub_users)
    .setIn([payload.id.toString(), 'message', 'completed'], payload.message)
    .setIn([payload.id.toString(), 'type', 'completed'], payload.type);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        USERS_UPDATE: updateStarted,
        USERS_UPDATE_COMPLETED: updateCompleted,
        USERS_UPDATE_FAILED: updateFailed,
        USERS_SHOW: showStarted,
        USERS_SHOW_COMPLETED: showCompleted,
        USERS_SHOW_CACHED: showCached,
        USERS_GET_ACCOUNT_USERS_COMPLETED: showAccountUsersCompleted,
        USERS_REMOVE_USER_ACCOUNT_COMPLETED: showAccountUsersCompleted,
        USERS_UPDATE_USER_ROLE_COMPLETED: showAccountUsersCompleted,
        USERS_SHOW_FAILED: showFailed,
        USERS_UPDATE_PASSWORD: updatePasswordStarted,
        USERS_UPDATE_PASSWORD_COMPLETED: updatePasswordCompleted,
        USERS_UPDATE_PASSWORD_FAILED: updatePasswordFailed,
        USERS_UPDATE_ATLAS: updateAtlasStarted,
        USERS_UPDATE_ATLAS_COMPLETED: updateAtlasCompleted,
        USERS_UPDATE_ATLAS_FAILED: updateAtlasFailed,
        USERS_RESET_UPDATE_PASSWORD_STATE: resetUpdatePasswordState,
        PENDING_INVITATIONS_COMPLETED: pendingInvitationCompleted,
        INVITE_SUB_USER_COMPLETED: pendingInvitationCompleted,
        REVOKE_INVITED_USER_COMPLETED: pendingInvitationCompleted,
        RESEND_INVITATION_COMPLETED: pendingInvitationCompleted,
      }[type] || (() => state)
    )(state, payload);
  });
}
